import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 *
 * @param state - the application state
 * @returns shiftReducer - the current businessShift reducer
 */
export const selectShiftReducer = (state: AppState) => state.businessShift

/**
 * Gets the openedShift object from the businessShift reducer
 */
export const selectBusinessOpenedShift = createSelector(
  selectShiftReducer,
  shiftState => shiftState.data.openedShift,
)

/**
 * Gets the loading flag from the businessShift reducer
 */
export const selectBusinessShiftLoading = createSelector(
  selectShiftReducer,
  shiftState => shiftState.isFetching,
)

/**
 * Gets the shift open positions from the businessShift reducer
 * We need to subtract the accepted count from the total count of positions for the shift to find the total number of open positions.
 */
export const selectBusinessShiftOpenPositions = createSelector(
  selectBusinessOpenedShift,
  shiftState => {
    const availablePositions =
      shiftState.positions - shiftState.applicants.accepted_count
    if (availablePositions < 0) {
      return 0
    }
    return availablePositions
  },
)

export const selectSuggestedPayRates = createSelector(
  selectShiftReducer,
  shiftState => shiftState.data.suggestedPayRates,
)
